import Vue from 'vue'
// import App from './App.vue'
import api from './api/api'
import index from './components/index'
import messageTip from './components/messageTip'

Vue.config.productionTip = false
Vue.prototype.$http = api

console.log(process.env.NODE_ENV)


new Vue({
  render: h => h(index)
}).$mount('#company');

new Vue({
  render: h => h(messageTip)
}).$mount('#messageTip');